import { date } from 'quasar'
import i18n from 'src/i18n'
import IsoDateTime, { timeContainer } from 'src/models/model/primitive-types/IsoDateTime'

export default class IsoDate extends Date {
  static name = 'IsoDate'

  static get currentTime () {
    return timeContainer.currentTime
  }

  get currentTime () {
    return timeContainer.currentTime
  }

  static parse (value, format = 'YYYY-MM-DD') {
    if (_.isString(value)) {
      const extractedDate = date.extractDate(value, format)
      // extractDate() can return a valid Date object even when it fails to
      // parse an invalid date string or is given no arguments. It returns
      // a valid date object equal to `new Date(null, null, null)`.
      // If we get this result, we want to return an invalid date instead.
      const zeroDate = new Date(null, null, null)
      if (extractedDate.toDateString() === zeroDate.toDateString()) {
        return new IsoDate(NaN)
      }

      return new IsoDate(extractedDate)
    } else {
      return new IsoDate(value)
    }
  }

  static encode (value) {
    if (!value) return null

    if (_.trim(value) === '') {
      return null
    } else if (_.isString(value)) {
      return value
    } else {
      return date.formatDate(value, 'YYYY-MM-DD')
    }
  }

  static daylightSavingsOffsetSeconds (currentDate, targetDate) {
    const currentDateTimezoneOffset = currentDate.getTimezoneOffset()
    const targetDateTimezoneOffset = targetDate.getTimezoneOffset()
    return targetDateTimezoneOffset - currentDateTimezoneOffset
  }

  isDate () {
    return this.toDateString() !== 'Invalid Date'
  }

  format (format = 'YYYY-MM-DD') {
    return date.formatDate(this, format)
  }

  toString () {
    return date.formatDate(this, 'YYYY-MM-DD')
  }

  i18n (format) {
    if (!this.isDate()) return null

    return i18n.global.d(new Date(this), format)
  }

  inTimeZone (timeZone) {
    const currentDate = new IsoDateTime()
    const timeConverted = new IsoDateTime(this.toLocaleString('en-US', { timeZone }))

    // Calculate the offset between the local time and the target time zone
    const offset = (currentDate.getTime() - new IsoDateTime(currentDate.toLocaleString('en-US', { timeZone })).getTime()) / 1000

    // Adjust the timeConverted by the offset
    timeConverted.setSeconds(timeConverted.getSeconds() + offset)

    return timeConverted
  }

  inGmt (timeZone) {
    const currentDate = new IsoDateTime()
    const dateOffset = new IsoDateTime(currentDate.toLocaleString('en-US', {
      timeZone
    }))
    const differenceInSeconds = (currentDate - dateOffset) / 1000
    const timeConverted = new IsoDateTime(this.toLocaleString('en-US', {
      timeZone
    }))
    timeConverted.setSeconds(timeConverted.getSeconds() - differenceInSeconds)
    return timeConverted
  }
}
